import React, { useEffect, useState } from 'react'
import { InputField } from '../../components/Input'
import AuthLayout from '../../layouts/AuthLayout'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ErrorStatus } from '../../components/FormStatus';
import resetPasswordRequest from '../../requests/resetPassword';
import { resetPassword } from '../../adapters/authentication';


export default function ResetPassword({ match }) {

  const params = useParams();

  const [errors, setErrors ] = useState([]);
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [passwordStrengthBar, setPasswordStrengthBar] = useState(false);
  const [isConfimed, setIsConfirmed] = useState(false);

  const navigate = useNavigate();
  
  useEffect(() => {
    if (password !== '') {
      setPasswordStrengthBar(true)
    }
  }, [password])
  
  useEffect(() => {
    if(password === confirmPassword){
      setIsConfirmed(true);
    }else{
      setErrors(['Password does not match']);
      setIsConfirmed(false);
    }
  }, [confirmPassword])
  

  const handleReset = async () => {
    if(isConfimed){
      await resetPasswordRequest.validate({ password }).then(() => {
        resetPassword({ token: params.token, password }).then((res) => {
          if (res.status === 200) {
            return navigate('/auth/sign-in', { replace: true })
          } else {
            setErrors(['Invalid or expired token']);
          }
        })
      }).catch((err) => {
        setErrors(['Invalid or expired token']);
      })
    }
  }


  return (
    <AuthLayout title="Reset Password">
      <ErrorStatus errors={errors} />
      <form onSubmit={(e) => {
        e.preventDefault();
        handleReset();
      }}>
        <InputField type="password" placeholder="******" showStrength={passwordStrengthBar} onChange={(e) => {
          setErrors([]);
          setPassword(e.target.value);
        }} defaultValue="" name="password" id="password" label="New Password" />
        <InputField type="password" isConfirmation={true} placeholder="******" onChange={(e) => {
          setErrors([])
          setConfirmPassword(e.target.value);
        }} defaultValue="" name="confirm_password" id="confirm_password" label="Confirm Password" />
        <div className="mt-6 px-3">
          <button className="py-3 font-fira hover:bg-blue-900 text-sm font-semibold w-full text-center flex justify-center items-center bg-blue-800 text-white rounded-lg " type="submit">
            Reset Password
          </button>
        </div>
      </form>
    </AuthLayout>
  )
}
